import { render, staticRenderFns } from "./PortalSelect.vue?vue&type=template&id=d237c9b2&"
import script from "./PortalSelect.vue?vue&type=script&lang=ts&"
export * from "./PortalSelect.vue?vue&type=script&lang=ts&"
import style0 from "./PortalSelect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports